import React, { useEffect, useState } from 'react';
import './LegalPage.css';
import Footer from '../../components/landing/Footer';
import Navbar from '../../components/landing/Navbar';
import { Snackbar, Alert } from '@mui/material';

import { useTheme } from '@mui/material/styles';

const LegalLayout = ({ title, lastUpdated, children }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    // Wallet State
    const [isConnected, setIsConnected] = useState(false);
    const [account, setAccount] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    useEffect(() => {
        window.scrollTo(0, 0);
        // Check for existing connection
        const storedAddress = localStorage.getItem('WalletAddress');
        if (storedAddress) {
            setAccount(storedAddress);
            setIsConnected(true);
        }

        if (typeof window.ethereum !== 'undefined' && window.ethereum.on) {
            window.ethereum.on('accountsChanged', (newAccounts) => {
                setAccount(newAccounts[0]);
                setIsConnected(newAccounts?.length > 0);
                if (newAccounts?.length > 0) {
                    localStorage.setItem('WalletAddress', newAccounts[0]);
                } else {
                    localStorage.removeItem('WalletAddress');
                }
            });
        }
    }, []);

    const handleConnect = async () => {
        if (!window.ethereum) {
            setSnackbarMessage('Please install MetaMask');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }

        try {
            const selectedAccount = await window.ethereum.request({
                method: 'eth_requestAccounts'
            });
            setAccount(selectedAccount[0]);
            localStorage.setItem('WalletAddress', selectedAccount[0]);
            setIsConnected(true);
            setSnackbarMessage('Connected to MetaMask');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
        } catch (error) {
            setSnackbarMessage('Connection error');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        }
    };

    const handleCloseSnackbar = () => setSnackbarOpen(false);

    return (
        <div className="legal-page-container" data-theme={isDark ? 'dark' : 'light'}>
            <Navbar
                onConnect={handleConnect}
                isConnected={isConnected}
                account={account}
            />
            <div className="legal-page-header">
                <h1>{title}</h1>
                <p className="last-updated">Last Updated: {lastUpdated}</p>
            </div>
            <div className="legal-page-card">
                <div className="legal-page-content">
                    {children}
                </div>
            </div>
            <div style={{ width: '100%', marginTop: 'auto' }}>
                <Footer />
            </div>

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default LegalLayout;
